import { SafeUrl } from '@angular/platform-browser';

export class Signature {
    filename: string;
    type: string;
    imageData: ArrayBuffer;
    url: SafeUrl;
    isWbacSignature: boolean;
}
